
<template>
  <div v-if="loading" class="d-flex justify-content-center align-items-center vh-100">
    <div class="spinner-border text-secondary" role="status">
    </div>
  </div>

  <div v-show="loading == false" class="boxWrapper d-flex flex-column rounded">
    
    <template :class="toggle == 'chat' ? 'd-block' : 'd-none'" style="height: calc(100vh - 80px); overflow: auto;">
      <ChatBox :checkChatState="checkChatState" />
    </template>

    <template :class="toggle == 'faq' ? 'd-block' : 'd-none'" style="height: calc(100vh - 80px);">
      <FaqBox :theme="theme" :site="site" :setloading="setLoading"/>
    </template>

    <template :class="toggle == 'feed' ? 'd-block' : 'd-none'" style="height: calc(100vh - 80px); overflow: auto;">
        <FeedBox :site="site" :updateNoteCount="updateNoteCount"/>
    </template>

    <div class="m-0 row rounded-bottom border-top" style=" z-index: 200; height: 80px; font-size: 12px; cursor: pointer; box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 25px;">
      <div class="col-4 pt-1 d-flex align-items-center justify-content-center flex-column rounded-top-0"  @click="toggle = 'faq'" :class="toggle=='faq'? 'btn-primary' : 'bg-white'"><i class="fa-regular fa-comments-question-check fa-2x"></i><span class="m-0">FAQ</span></div>
      <div class="col-4 pt-1 d-flex align-items-center justify-content-center flex-column" @click="toggle = 'chat'" :class="toggle=='chat'? 'btn-primary' : 'bg-white'"><div class="d-flex position-relative"><i class="fa-regular fa-headset fa-2x"></i><div v-if="chatOnline" class="rounded-circle online shadow" style="background-color: #45E900; height: 8px; width : 8px;top: -3px;right: -8px;position: absolute;"></div>
    </div>{{chatOnline? 'Chatta': 'Kontakt'}} 
      </div>
      
      <div class="col-4 pt-1 d-flex align-items-center justify-content-center flex-column rounded-top-0 position-relative "  @click="toggle = 'feed'" :class="toggle=='feed'? 'btn-primary' : 'bg-white'"> 
        <div class="d-flex position-relative">
        <i class="fa-regular fa-mobile fa-2x"></i>
          <div class="d-flex text-center align-items-center justify-content-center position-absolute rounded-circle" style="background-color: #9E0C3D; top: -4px; right: -9px; font-size: 8px; color: #fff; width: 15px; height: 15px;">{{noteCount}}</div> 
        </div>
        Appstatus
   
    </div>
    </div>

  </div>  


  <ComponentStyles>
    * {
    box-sizing:border-box;
    }

    #boxSearchInput{
     }

    #boxSearchInput:focus-visible {
      
      outline: none;
    }
    
    .boxWrapper header{
      {{ theme.bgimage }}

    }
    .boxWrapper {
    {{ theme.bg }}
    

    box-sizing: border-box;
    }

    .boxWrapper .title {
      font-size: 14px;
    }

    .iconBg {
    width: 36px;
    height: 36px;
    {{ theme.iconBg }}
    }


    .boxWrapper ::-webkit-scrollbar {
    width: 0;
    height: 4px;
    }

    .livechatBtn{
    border-radius: 2em;
    font-weight: 600;
    }

    .slide-main-leave-active,
    .slide-main-enter-active {
    transition: all 0.1s ease-in;
    }


    .slide-main-leave-to,
    .slide-main-enter-from {
    transform: translateX(200px);
    opacity: 0;
    }

    .slide-sub-enter-active {
    transition: all .3s ease-in;
    }


    .slide-sub-leave-to,
    .slide-sub-enter-from {
    transform: translateY(15px);
    opacity: 0;
    }


    @media screen and (max-width: 576px) {
      

      .toggleBtn {
        position: absolute;
        border-radius: 0 !important;
        transform: rotate(45deg);
        height: 300px !important; 
        right: 0;
      }

      .toggleBtn i {
        position: relative;
        bottom: 22px;
        right: 5px;
        transform: rotate(-45deg);
      }

      .toggleBtn .rounded-circle {
        top: 105px !important;
        right: 32px !important;
        z-index: 90;
        border:0 !important;
      }

      .helpText {
        display: none;
      }


    }

    #boxQuestionAccordion .accordion-item{
      border-bottom: 1px solid #dee2e6;
    }
    
    #boxQuestionAccordion.accordion-header{
      font-size: 1em;
      margin: 0;
    }
    
    #boxQuestionAccordion .accordion-button{
        font-weight: 600;
        border: 0 !important;
        background: none;
        font-size: 1em !important;
        display: block;
        width: 100%;
        text-align: left;
        padding: 16px 0;
    }
    #boxQuestionAccordion .accordion-button:focus{
        outline: none !important;
    }
    .inside-wrapper .fa-arrow-left.fs-2 {
        color: #fff;
        font-size: 30px;
        margin-right: 10px;
    }




  </ComponentStyles>
</template>

<script>

import ChatBox from "./ChatBox.vue";
import FeedBox from "./FeedBox.vue";
import ComponentStyles from "../componentStyles.vue";
import FaqBox from "./FaqBox.vue";
export default {


  props: ['site'],

  data() {
    let chatOnline = false;
    let showFaq = false;
    let toggleIcon = "fa-solid fa-question-circle fs-2";
    let toggle = 'faq';

    let theme = {
      toggleBtn: "background: #47525D; color: #FFF2E3;",
      chatBtn: 'background : #47525D; color: #FFFFFF;',
      bg: "background-color: #F0EEEA;",
      iconBg: 'background : #FFF2E3; color: #47525D;',
      helpText: 'background: #47525D; color: #FFFFFF;',
      darkText: 'color: #47525D',
      bgimage: 'background: #F0EEEA url("//cdn.gavleenergi.se/img/geab/faq_bg.jpg") no-repeat;background-size: 100% auto;',


    }



    if (this.site == "gn") {
      theme = {
        toggleBtn: "background: #0C555B; color: #DA9C4F;",
        chatBtn: 'background : #0C555B ; color: #fff;',
        bg: "background: #E6EFF1;",
        iconBg: 'background: #06070B; color: #DA9C4F;',
        helpText: 'background: #E6EFF1; color: #0C555B;',
        darkText: 'color: #0C555B',
        
      bgimage: 'background: #F0EEEA url("//cdn.gavleenergi.se/img/gavlenet/faq_bg.jpg") no-repeat;background-size: 100% auto;',
      }
    }




    return {
      loading: true,
      chatOnline,
      showFaq,
      toggleIcon,
      theme,
      toggle,
      noteCount : 0

    }


  },

  components: { ChatBox, ComponentStyles, FaqBox, FeedBox },

  methods: {
    updateNoteCount(count){
      this.noteCount = count
      console.log("Antal statusar: " + count)
    },
    setLoading(status){
this.loading = status

    },

    checkChatState(status) {
      this.chatOnline = status;
      this.iconControl()
    },

    iconControl() {
      if (this.showFaq == false && this.chatOnline == false) {
        this.toggleIcon = "fa-solid fa-question-circle fs-2"
      }

      else if (this.showFaq == false && this.chatOnline == true) {
        this.toggleIcon = " fa-solid fa-message-lines fs-3"
      }

      else { this.toggleIcon = "fa-light fa-xmark fs-3" }
    },


  },



  watch: {


    showFaq() {
      this.iconControl()
    },

  },


}
</script>
